import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import axios from "axios";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const initialRows = [
  {
    id: 1,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
  {
    id: 2,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
];
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer></GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "تقرير الدفعات",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const AmountReports = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState(initialRows);

  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/Paymentreports`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(res.data.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const columns = [
    {
      field: "staff_from",
      headerName: "المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "from_mobile_number",
      headerName: "رقم موبايل المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },

    {
      field: "staff_to",
      headerName: "المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "to_mobile_number",
      headerName: "رقم موبايل المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to_type",
      headerName: "نوع المستقبل",

      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },

    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount",
      headerName: "الرصيد المطلوب",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore",
      headerName: "الرصيد قبل التحويل",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد التحويل",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "code_name_ar",
      headerName: "النوع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
  ];

  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
            toolbarColumns: "الأعمدة",
            toolbarFilters: "الفلاتر",
            toolbarDensity: "التباعد",
            toolbarExport: "تصدير",
            filterPanelAddFilter: "إضافة فلتر",
            filterOperatorContains: "تحتوي",
            filterOperatorEquals: "تساوي",
            filterOperatorStartsWith: "تبدأ ب",
            filterOperatorEndsWith: "تنتهي  ب",
            filterOperatorIsAnyOf: "هو أي من",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "غير فارغ",
            toolbarDensityCompact: "دمج",
            toolbarDensityStandard: "معيار",
            toolbarDensityComfortable: "مريح",
            toolbarExportCSV: "تصدير CSV",
            toolbarExportPrint: "طباعة",
            filterPanelInputLabel: "القيمة",
            filterPanelInputPlaceholder: "ادخل القيمة",
            filterPanelColumns: "الاعمدة",
            filterPanelOperators: "العمليات",
            columnsPanelTextFieldLabel: "بحث عن عمود",
            columnsPanelTextFieldPlaceholder: "عنوان العمود",
          }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default AmountReports;
